import React from 'react'

import { Card, CardContent, Grid } from '@mui/material'
import { Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

type CampaignHealthChartsProps = {
  stats: any
}

const CampaignHealthCharts = ({ stats }: CampaignHealthChartsProps) => {
  const statsWithCtr = stats.reduce((acc: any, { views, clicks, ...rest }: any, idx: number) => {
    const { sumViews: prevSumViews = 0, sumClicks: prevSumClicks = 0 } = acc[idx - 1] || {}
    const sumViews = prevSumViews + views
    const sumClicks = prevSumClicks + clicks
    return [
      ...acc,
      {
        ctr: sumViews ? (sumClicks / sumViews) * 100 : 0,
        sumViews,
        sumClicks,
        views,
        clicks,
        ...rest,
      },
    ]
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          sm: 6,
        }}>
        <Card>
          <CardContent>
            <ResponsiveContainer className="campaign-health__chart" height={200}>
              <LineChart data={stats} margin={{ left: -20 }}>
                <YAxis />
                <XAxis dataKey="date" />
                <Tooltip />
                <Legend iconType="circle" />
                <Line dataKey="views" dot={false} name="Views" stroke="#0D47A1" type="monotone" />
                <Line dataKey="exchangeViews" dot={false} name="Exchange Views" stroke="#90CAF9" type="monotone" />
              </LineChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid>
      <Grid
        size={{
          sm: 6,
        }}>
        <Card>
          <CardContent>
            <ResponsiveContainer className="campaign-health__chart" height={200}>
              <LineChart data={stats} margin={{ right: -20 }}>
                <YAxis orientation="right" />
                <XAxis dataKey="date" />
                <Tooltip />
                <Legend iconType="circle" />
                <Line dataKey="clicks" dot={false} name="Clicks" stroke="#1B5E20" type="monotone" />
                <Line dataKey="exchangeClicks" dot={false} name="Exchange Clicks" stroke="#A5D6A7" type="monotone" />
              </LineChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid>
      <Grid
        size={{
          sm: 12,
        }}>
        <Card>
          <CardContent>
            <ResponsiveContainer className="campaign-health__chart" height={200}>
              <LineChart data={statsWithCtr} margin={{ left: -20, right: -20 }}>
                <YAxis yAxisId="left" />
                <YAxis orientation="right" yAxisId="right" />
                <XAxis dataKey="date" />
                <Tooltip />
                <Legend iconType="circle" />
                <Line dataKey="views" dot={false} name="Views" stroke="#64B5F6" type="monotone" yAxisId="left" />
                <Line dataKey="clicks" dot={false} name="Clicks" stroke="#2E7D32" type="monotone" yAxisId="left" />
                <Line
                  dataKey={({ ctr }: any) => ctr.toFixed(2)}
                  name="CTR"
                  stroke="#A5D6A7"
                  strokeDasharray="5 5"
                  type="monotone"
                  yAxisId="right"
                />
              </LineChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default CampaignHealthCharts
